import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/VisibilityPublic.svg'

export const IconVisibilityPublic = IconSVG as IconComponent
